"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.proto_showBattlescape = exports.proto_showGeoscape = exports.holeStillnessTolerance = exports.innerHoleDistance = exports.holeGravityMaxDistance = exports.holeDrag = exports.holeGravity = exports.rule_teams = exports.rule_advancedFlingPosition2 = exports.rule_advancedFlingPosition = exports.rule_requireQuadrant = exports.rule_requireOnStartingLine = exports.debug_gameSync = exports.debug_crcs_report_mismatch = exports.debug_crcs_extra_drift_checks = exports.debug_crcs_round = exports.debug_crcs = exports.debugMp_showDiscIds = exports.allowMpDebug = exports.debugSuperHoleGravity = exports.debugTokensInHole = exports.debugCollisions = exports.debugHole = exports.debugQuadrant = exports.debugIsOnStartingLine = exports.debugIsInCenter = exports.debugScoring = exports.debugGamepad = exports.debugPucks = exports.allowDebug = exports.noDebug = exports.playAreaRadius = exports.holeSensorRadius = exports.poleRadius = exports.placerSensorRadius = exports.discAngularDamping = exports.discLinearDamping = exports.discFriction = exports.discRestitution = exports.puckRadius = exports.wallLength = exports.wallThickness = exports.worldSize = exports.physicsScale = exports.physicsMultiplier = exports.CrokinoleDiscSymbols = exports.CollisionGroups = exports.CollisionMembershipMultiplier = exports.CollisionGroupFlags = exports.multiplayerVersion = void 0;
exports.debug_fasterLevelGen = exports.maxSettleTime = exports.maxEnemyTurnTime = exports.debug_combinedWalls = exports.debug_startLevel = exports.debug_testAlwaysDrop = exports.debug_testBrokenLevel = exports.debug_testLockedLevel = exports.debug_noEnemies = exports.debug_useTestRegion = exports.debug_trapType = exports.debug_enemyType = exports.debug_freezeEnemies = exports.debug_disallowDeath = exports.debug_ezAmulet = exports.debug_dontAutoCamera = exports.debug_placerSensor = exports.debug_instantEnemyFling = exports.debug_dontWaitForStillness = exports.stillnessTolerance = exports.heightInSections = exports.widthInSections = exports.allStillMaxTime = void 0;
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
exports.multiplayerVersion = '0.1.1-kft';
exports.CollisionGroupFlags = {
    ground: 1,
    flying: 2,
    particle: 4,
    groundAndFlying: 3,
    all: 7,
    inactive: 0,
};
exports.CollisionMembershipMultiplier = 65536;
exports.CollisionGroups = {
    ground: exports.CollisionGroupFlags.ground +
        exports.CollisionGroupFlags.ground * exports.CollisionMembershipMultiplier,
    flying: exports.CollisionGroupFlags.flying +
        exports.CollisionGroupFlags.flying * exports.CollisionMembershipMultiplier,
    groundAndFlying: exports.CollisionGroupFlags.groundAndFlying +
        exports.CollisionGroupFlags.groundAndFlying * exports.CollisionMembershipMultiplier,
    particle: exports.CollisionGroupFlags.particle +
        exports.CollisionGroupFlags.particle * exports.CollisionMembershipMultiplier,
    all: exports.CollisionGroupFlags.all +
        exports.CollisionGroupFlags.all * exports.CollisionMembershipMultiplier,
    none: exports.CollisionGroupFlags.inactive +
        exports.CollisionGroupFlags.inactive * exports.CollisionMembershipMultiplier,
    // playarea:
    //   CollisionGroupFlags.playarea +
    //   CollisionGroupFlags.playarea * CollisionMembershipMultiplier,
    // gutter:
    //   CollisionGroupFlags.gutter +
    //   CollisionGroupFlags.gutter * CollisionMembershipMultiplier,
    // both:
    //   CollisionGroupFlags.both +
    //   CollisionGroupFlags.both * CollisionMembershipMultiplier,
    // inactive:
    //   CollisionGroupFlags.inactive +
    //   CollisionGroupFlags.inactive * CollisionMembershipMultiplier,
};
exports.CrokinoleDiscSymbols = [
    {
        name: 'None',
        frame: null,
    },
    {
        name: 'Star',
        frame: sprites_sidecar_1.sprites.crokinoleDiscStar[0],
    },
    {
        name: 'Leaf',
        frame: sprites_sidecar_1.sprites.crokinoleDiscLeaf[0],
    },
    {
        name: 'Spiral',
        frame: sprites_sidecar_1.sprites.crokinoleDiscSpiral[0],
    },
    {
        name: 'Smile',
        frame: sprites_sidecar_1.sprites.crokinoleSymbolSmile[0],
        scale: 0.75,
    },
    {
        name: 'Ukulele',
        frame: sprites_sidecar_1.sprites.crokinoleSymbolUkulele[0],
    },
    {
        name: 'Poodle',
        frame: sprites_sidecar_1.sprites.crokinoleAnimalPoodle[0],
        scale: 0.55,
        noTint: false,
    },
    {
        name: 'Wrench',
        frame: sprites_sidecar_1.sprites.crokinoleItemWrench2[0],
        scale: 1,
        noTint: false,
    },
    {
        name: 'Alien',
        frame: sprites_sidecar_1.sprites.crokinoleMonsterAlien[0],
        scale: 0.67,
        noTint: true,
    },
    {
        name: 'Extinguisher',
        frame: sprites_sidecar_1.sprites.crokinoleItemExtinguisher[0],
        scale: 1,
        noTint: true,
    },
    {
        name: 'Coffee',
        frame: sprites_sidecar_1.sprites.crokinoleItemCoffee[0],
        scale: 2,
        noTint: true,
    },
    {
        name: 'Archer',
        frame: sprites_sidecar_1.sprites.diveHeroes2WeeMonsArcherAtkR1Png[0],
        scale: 0.9,
        noTint: true,
    },
    {
        name: 'Swordfighter',
        frame: sprites_sidecar_1.sprites.diveHeroes2WeeMonsFighterAtkR2Png[0],
        scale: 0.9,
        noTint: true,
    },
    {
        name: 'Wizard',
        frame: sprites_sidecar_1.sprites.diveHeroes2WeeMonsMageAtkR2Png[0],
        scale: 0.9,
        noTint: true,
    },
];
exports.physicsMultiplier = 1 / 100;
// Render scale
exports.physicsScale = 120; // Target is 128?
exports.worldSize = 781 * exports.physicsMultiplier;
exports.wallThickness = 32 * exports.physicsMultiplier;
exports.wallLength = 715 * exports.physicsMultiplier;
exports.puckRadius = (32 / 2) * exports.physicsMultiplier;
exports.discRestitution = 0.9;
exports.discFriction = 0.9;
exports.discLinearDamping = 0.95;
exports.discAngularDamping = 0.5;
exports.placerSensorRadius = (35 / 2) * exports.physicsMultiplier;
exports.poleRadius = (9.5 / 2) * exports.physicsMultiplier;
exports.holeSensorRadius = (35 / 2) * exports.physicsMultiplier;
exports.playAreaRadius = ((662 + 10) / 2) * exports.physicsMultiplier;
exports.noDebug = false;
exports.allowDebug = !exports.noDebug;
exports.debugPucks = true && exports.allowDebug;
exports.debugGamepad = false;
exports.debugScoring = false && exports.allowDebug;
exports.debugIsInCenter = false && exports.allowDebug;
exports.debugIsOnStartingLine = false && exports.allowDebug;
exports.debugQuadrant = false && exports.allowDebug;
exports.debugHole = false && exports.allowDebug;
exports.debugCollisions = true && exports.allowDebug;
exports.debugTokensInHole = true && exports.allowDebug;
exports.debugSuperHoleGravity = true && exports.allowDebug;
exports.allowMpDebug = true;
exports.debugMp_showDiscIds = false && exports.allowMpDebug;
exports.debug_crcs = false;
exports.debug_crcs_round = false;
exports.debug_crcs_extra_drift_checks = true;
exports.debug_crcs_report_mismatch = false;
exports.debug_gameSync = false;
exports.rule_requireOnStartingLine = true || exports.noDebug;
exports.rule_requireQuadrant = true || exports.noDebug;
exports.rule_advancedFlingPosition = false; // || noDebug
exports.rule_advancedFlingPosition2 = false; // || noDebug
exports.rule_teams = true;
// Add hole gravity
exports.holeGravity = 0.003;
exports.holeDrag = 0.002;
exports.holeGravityMaxDistance = 0.15;
exports.innerHoleDistance = exports.holeGravityMaxDistance / 2;
exports.holeStillnessTolerance = 0.25;
exports.proto_showGeoscape = false;
exports.proto_showBattlescape = true;
// new for minigolf
exports.allStillMaxTime = 0.1;
exports.widthInSections = 8;
exports.heightInSections = 6;
// updated for minigolf
exports.stillnessTolerance = 0.125;
exports.debug_dontWaitForStillness = false && !exports.noDebug;
exports.debug_instantEnemyFling = false && !exports.noDebug;
exports.debug_placerSensor = false && !exports.noDebug;
exports.debug_dontAutoCamera = false && !exports.noDebug;
exports.debug_ezAmulet = false && !exports.noDebug;
exports.debug_disallowDeath = false && !exports.noDebug;
exports.debug_freezeEnemies = false && !exports.noDebug;
exports.debug_enemyType = exports.noDebug ? '' : '';
exports.debug_trapType = exports.noDebug ? '' : '';
exports.debug_useTestRegion = false && !exports.noDebug;
exports.debug_noEnemies = false && !exports.noDebug;
exports.debug_testLockedLevel = false && !exports.noDebug;
exports.debug_testBrokenLevel = false && !exports.noDebug;
exports.debug_testAlwaysDrop = false && !exports.noDebug;
exports.debug_startLevel = exports.noDebug ? 0 : 0;
exports.debug_combinedWalls = false && !exports.noDebug;
exports.maxEnemyTurnTime = 5;
exports.maxSettleTime = 7;
exports.debug_fasterLevelGen = true;
